import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { INDUSTRIES, IMAGES } from "../lib/data";
import { PageHero, CTABand } from "../components/site/Bits";
import { Reveal } from "../components/site/Reveal";

import { Seo } from "../components/site/Seo";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <Seo title="Sectors We Serve" description="Industry-specific environmental and jobsite solutions for oil & gas, pipeline, heavy construction, utilities, hazmat, fire departments, and more." />
      <PageHero
        kicker="Sectors We Serve"
        title="Organized by sector, built to grow."
        subtitle="Every sector works differently. We match best-in-class products and solutions to how your crews actually operate — and expand each sector's portfolio over time."
        image={IMAGES.excavators}
      />
      <section className="bg-background">
        <div className="container-x py-24">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.slug} delay={(i % 3) * 0.08}>
                <Link to={`/industries/${ind.slug}`} data-testid={`industry-card-${ind.slug}`} className="group relative block border border-border bg-card overflow-hidden hover:border-flame/60 hover:-translate-y-1.5 hover:shadow-2xl transition-[transform,box-shadow,border-color] duration-300 ease-[cubic-bezier(0.25,1,0.5,1)] h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-flame focus-visible:ring-offset-2">
                  <span aria-hidden="true" className="absolute top-0 left-0 z-20 h-full w-1 bg-flame origin-top scale-y-0 group-hover:scale-y-100 transition-transform duration-500 ease-out" />
                  <div className="relative h-52 overflow-hidden">
                    <img src={ind.image} alt={ind.name} className="absolute inset-0 h-full w-full object-cover group-hover:scale-110 transition-transform duration-700 ease-[cubic-bezier(0.25,1,0.5,1)]" />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent group-hover:from-ink/85 transition-colors duration-500" />
                  </div>
                  <div className="p-6">
                    <h3 className="font-display font-bold text-xl text-ink group-hover:text-flame transition-colors">{ind.name}</h3>
                    <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{ind.blurb}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-flame text-sm font-semibold">
                      Explore solutions <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
